module.exports = __webpack_public_path__ + "img/projection-slide.d8d746a5.svg";